module.exports = __webpack_public_path__ + "assets/2a665d74e9d4af45c79bcc333b1f27f5.jpg";